"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _TickOutlined = require("../../../icons/TickOutlined");
var _addToBasketSuccessModule = _interopRequireDefault(require("./add-to-basket-success.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var AddToBasketSuccess = function AddToBasketSuccess(_ref) {
  var _ref$goToBasket = _ref.goToBasket,
    goToBasket = _ref$goToBasket === void 0 ? function () {} : _ref$goToBasket,
    _ref$shortCtaText = _ref.shortCtaText,
    shortCtaText = _ref$shortCtaText === void 0 ? false : _ref$shortCtaText;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _addToBasketSuccessModule.default.container,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _addToBasketSuccessModule.default.tick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TickOutlined.TickOutlined, {
        size: "small"
      })
    }), "Added to", ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
      className: _addToBasketSuccessModule.default.link,
      href: "/basket",
      onClick: goToBasket,
      children: shortCtaText ? 'basket' : 'your basket'
    })]
  });
};
AddToBasketSuccess.propTypes = {
  goToBasket: _propTypes.default.func,
  shortCtaText: _propTypes.default.bool
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(AddToBasketSuccess);